// client/src/components/School_Admin/Dashboard/StudentsPerClassChart.js
//
// A PIE, NOT A BAR. See the note at the top of DistributionPie: a bar chart
// shares one ceiling across every class, so a school with one large class and
// eleven small ones drew a single full-height column beside eleven stubs, and
// a school with forty classes drew forty four-pixel columns. The question this
// chart is asked is how the roll is split, which is a share — and a share does
// not stop working when the school grows.

import React from 'react';
import DistributionPie from './DistributionPie';

const StudentsPerClassChart = ({ data }) => (
  <DistributionPie
    // The overview has shipped three spellings of this field over time and the
    // list still arrives with any of them, so all three are read rather than
    // letting one rename blank the chart.
    items={(Array.isArray(data) ? data : []).map((item) => ({
      label: item.className || item.class || item.name || 'Class',
      value: item.count,
    }))}
    unitLabel="students"
    emptyText="No student distribution data available"
  />
);

export default StudentsPerClassChart;
